// eneum to refer to simple cell
export const SIMPLE = 'simple';
// eneum to refer to header cell
export const TEXT = 'text';
// enum to refer to axis cell
export const AXIS = 'axis';
// enum to refer to visual cell
export const GEOM = 'geom';
// enum to refer blank cell
export const BLANK = 'blank';
